import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

/** Reloads File Finder files whenever the File Finder becomes visible. */
export const loadFinderFilesOnFinderOpen = store.effects.create(
  (feature: Feature) =>
    feature.actions.displayFinder.observe().pipe(
      rxjs.switchMap(action =>
        feature.selectors.finderIsOpen.asObservable.pipe(
          rxjs.take(1),
          rxjs.filter(isOpen => isOpen),
          rxjs.map(() => action),
        ),
      ),
      rxjs.map(action =>
        feature.actions.loadFinderFiles.request.from(action).create(),
      ),
    ),
)
